"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Notifications Macroservice
 * A collection of services related to Notifications.  Includes send services (for outbound transactional notifications), and webhooks (for inbound updates related to previously sent notifications).    Future enhancements include support for outbound marketing emails and additional channels, like SMS.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSendResultDto = instanceOfSendResultDto;
exports.SendResultDtoFromJSON = SendResultDtoFromJSON;
exports.SendResultDtoFromJSONTyped = SendResultDtoFromJSONTyped;
exports.SendResultDtoToJSON = SendResultDtoToJSON;
exports.SendResultDtoToJSONTyped = SendResultDtoToJSONTyped;
var send_error_dto_1 = require("./send-error-dto");
/**
 * Check if a given object implements the SendResultDto interface.
 */
function instanceOfSendResultDto(value) {
    if (!('attempted' in value) || value['attempted'] === undefined)
        return false;
    if (!('succeeded' in value) || value['succeeded'] === undefined)
        return false;
    if (!('failed' in value) || value['failed'] === undefined)
        return false;
    return true;
}
function SendResultDtoFromJSON(json) {
    return SendResultDtoFromJSONTyped(json, false);
}
function SendResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'attempted': json['attempted'],
        'succeeded': json['succeeded'],
        'failed': json['failed'],
        'errors': json['errors'] == null ? undefined : (json['errors'].map(send_error_dto_1.SendErrorDtoFromJSON)),
    };
}
function SendResultDtoToJSON(json) {
    return SendResultDtoToJSONTyped(json, false);
}
function SendResultDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'attempted': value['attempted'],
        'succeeded': value['succeeded'],
        'failed': value['failed'],
        'errors': value['errors'] == null ? undefined : (value['errors'].map(send_error_dto_1.SendErrorDtoToJSON)),
    };
}
